import { AssistantLayout } from "@app/components/assistant/AssistantLayout";
import { ErrorDisplay } from "@app/components/assistant/conversation/ConversationError";
import { ConversationSidePanelProvider } from "@app/components/assistant/conversation/ConversationSidePanelContext";
import { FilePreviewProvider } from "@app/components/assistant/conversation/FilePreviewContext";
import { FileDropProvider } from "@app/components/assistant/conversation/FileUploaderContext";
import { GenerationContextProvider } from "@app/components/assistant/conversation/GenerationContextProvider";
import { ErrorBoundary } from "@app/components/error_boundary/ErrorBoundary";
import type { AuthContextValue } from "@app/lib/auth/AuthContext";
import type React from "react";

function UncaughtHomeErrorFallback() {
  return (
    <ErrorDisplay
      title="Something unexpected happened"
      message={["Try refreshing the page to get back to your Home."]}
    />
  );
}

/**
 * Home carries a composer and, in the task panel, a whole conversation, so it
 * needs the same providers a conversation route does — minus everything keyed
 * to an active conversation id, which Home does not have.
 */
export function HomeLayout({
  children,
  pageProps,
}: {
  children: React.ReactNode;
  pageProps: AuthContextValue;
}) {
  const { workspace, user } = pageProps;

  return (
    <AssistantLayout owner={workspace} user={user}>
      <ConversationSidePanelProvider>
        <FilePreviewProvider owner={workspace}>
          <ErrorBoundary fallback={<UncaughtHomeErrorFallback />}>
            <FileDropProvider>
              <GenerationContextProvider>
                <div className="flex h-full w-full flex-col">
                  {children}
                </div>
              </GenerationContextProvider>
            </FileDropProvider>
          </ErrorBoundary>
        </FilePreviewProvider>
      </ConversationSidePanelProvider>
    </AssistantLayout>
  );
}
